let pinyin = require("js-pinyin")
//根据城市首字母排序
function getCitySort(cityData) {
    //cityData格式===>['广州','湛江',...]
    let cityP = []//现有城市拼音
    let cityRel = []//可被调用的真实数据

    //获取城市首字母

    cityData.map((e) => {
        cityP.push(pinyin.getFullChars(e).slice(0, 1))
    })

    //去重;

    cityP = [...new Set(cityP)]
    //排序

    cityP.sort()

    //算法----根据拼音首字母对城市进行分组
    cityP.map((p) => {
        let tem = []
        cityData.map((d) => {
            if (pinyin.getFullChars(d).slice(0, 1) == p) {
                tem.push(d)
            }
        })
        cityRel.push({ label: p, value: tem })
    })
return cityRel
}

module.exports = {
    getCitySort: getCitySort,
}